import { DatabaseCacheService } from 'src/app/data/cache/database-cache.service';
import { getIsoDateTimeString } from 'src/app/utils';
import { MsalService } from '@azure/msal-angular';
import {MatCardModule} from '@angular/material/card';
import { GOST_I18N, getRecommendationsArray, getDescriptionsArray, getDssDescArray } from './gost.i18n';

export class GostUtils {

  public newGostId = "new_gost";

  // index系はすべて0から始まり、FILSの分解能に相当する0-10の値を格納する
  // 推定FILS値に基づいて食形態の1位を決定する。eFilsIndexが最も分解能が高い0-10のため、ほかはこれにマッピングする
  // gostParams.eFilsIndex が最終的に１位の食形態を決定する
  // eFilsIndex に対応するFILS値とSCレベルのマッピング
  FilsGrade = [1, 2, 3, 4, 5, 6, 7, 7, 8, 9, 10];
  SCMapIndex =[0, 0, 1, 1, 2, 2, 3, 4, 5, 6, 7];

  // SCMapIndexに対応する食形態のリスト
  recommendations = getRecommendationsArray();
  descriptions = getDescriptionsArray();

  dssDesc = getDssDescArray();

  //0がFILSのスコアで選ばれた食形態で、1が次点、2が次点、3が最低ランク
  rankingPatterns = {
    "6": [3, 0, 1, 2],
    "5": [2, 0, 1, 3],
    "4": [2, 0, 1, 3],
    "3": [3, 1, 0, 2],
    "2": [2, 1, 0, 3],
    "1": [3, 2, 1, 0]
  };

  public PrimarilySelectedFoods;
  public SecondarySelectedFoods =[];
  SelectedFoods;

  public WithOrWithoutThickness = {
    withoutThickness: "withoutThicknessSteps",
    withThickness: "withThicknessSteps"
  }

  public testResultDisp = {
    good: 'radio_button_unchecked', // 丸印
    acceptable: '△',
    bad: 'clear', // バツ印
    notMeasured: "-",
  }

  public evaluateGost(gostRecord) {

    this.evaluateGcOc(gostRecord.data.gostGCData);
    this.evaluateGcOc(gostRecord.data.gostOCData);
    this.evaluateSc(gostRecord);

    const gostData = gostRecord.data;

    let gostParams = {
      SCL: 0,
      SCLINDEX: 0,
      SCL_WT: 0,
      SCL_WTINDEX: 0,
      SCLEVEL: 0,
      SCINDEX: 0,
      SCSCORE: 0,

      GCLEVEL: 0,
      GCSCORE: 0,
      OCLEVEL: 0,
      OCSCORE: 0,
      GOSTSCORE: 0,
      GOSTLEVEL: 0,
      eDSS: 0,
      eFILS: 0,
     eFilsIndex: 0
      }

    // SCL の代入　nullが入ることを許容する
    gostParams.SCL = gostData.gostSCData.level;
    gostParams.SCLINDEX = gostData.gostSCData.index;

    // SC Level WT の代入
    gostParams.SCL_WT = gostData.gostSCData.withThicknessLevel;
    gostParams.SCL_WTINDEX = gostData.gostSCData.withThicknessIndex;

    // SC Level の代入
    gostParams.SCLEVEL = gostParams.SCL > gostParams.SCL_WT ? gostParams.SCL : gostParams.SCL_WT;
    gostParams.SCINDEX = gostParams.SCL > gostParams.SCL_WT ? gostParams.SCLINDEX : gostParams.SCL_WTINDEX;

    // SC Score の代入
    gostParams.SCSCORE = gostData.gostSCData.totalScore;

    // OC Level の代入
    gostParams.OCLEVEL = gostData.gostOCData.level;

    // GC Score の代入
    gostParams.GCLEVEL = gostData.gostGCData.level;

    // GOST level の代入 SCL+OClevel+GCLevel < 1　または　SCLがnull のときは1
    gostParams.GOSTLEVEL =
    (gostParams.SCL + gostParams.OCLEVEL + gostParams.GCLEVEL) < 1 || gostParams.SCL == null ? 1 : (gostParams.SCL ?? 0) + (gostParams.OCLEVEL ?? 0) + (gostParams.GCLEVEL ?? 0);
    gostData.gostLevel = gostParams.GOSTLEVEL;

    // gostスコア = とろみ無しscスコア + ocスコア + GCスコア。　　gostレベル = とろみ無しSCレベル + OCレベル + GC レベル
    gostParams.GOSTSCORE = (gostData.gostSCData.totalScore ?? 0) + (gostData.gostOCData.totalScore ?? 0) + (gostData.gostGCData.totalScore ?? 0);
    gostData.gostScore = gostParams.GOSTSCORE;// データベースにはアップロードされない

    // gostレベル と scレベルの平均をベースとして、gostスコア に応じて補正する
    if (gostParams.GOSTLEVEL != null && gostParams.SCLEVEL != null) {
      gostParams.eDSS = Math.floor((gostParams.GOSTLEVEL + gostParams.SCL) / 2.0);
      gostData.dss = gostParams.eDSS;
      gostData.dssDesc = this.dssDesc[gostData.dss - 1];
    }
    else {
      gostParams.eDSS = null;
      gostData.dss = null;
      gostData.dssDesc = null;
    }

    let adjustment = 0;
    // SCLevel をGOST スコアに対して条件を決めた減算して調整を行ったものをFILSとする
    if (gostParams.GOSTSCORE != null) {
      if (gostParams.GOSTSCORE <= -15) {
        adjustment = -4;
      } else if (gostParams.GOSTSCORE <= -10) {
        adjustment =  -3;
      } else if (gostParams.GOSTSCORE <= -5) {
        adjustment = -2;
      } else if (gostParams.GOSTSCORE <= 0) {
        adjustment = -1;
      } else {
        adjustment = 0;
      }
      gostParams.eFilsIndex = gostParams.SCINDEX + adjustment < 0 ? 0 : gostParams.SCINDEX + adjustment > 10 ? 10 : gostParams.SCINDEX + adjustment;

      gostParams.eFILS = this.FilsGrade[gostParams.eFilsIndex];
      gostData.filsGrade = gostParams.eFILS;
      gostData.filsRecommendation = this.recommendations[this.SCMapIndex[gostParams.eFilsIndex]];
      gostData.scRecommendation = this.recommendations[this.SCMapIndex[gostParams.SCINDEX]];

    }
    else {
      gostParams.eFILS = null;
      gostData.filsGrade = null;
      gostData.filsRecommendation = null;
    }

    gostData.PrimarilySelectedFoods = this.getSelectedFoods(gostParams.eFilsIndex , gostParams.GOSTLEVEL); //selevtedFoodsのオブジェクトの取得

    //PrimarilySelectedFoods をrankでソートして、"該当なし"以外で最もランクが高いものを選択
    let maxRank = 0;
    let selectedFood = null;
    for (var food of gostData.PrimarilySelectedFoods.selectedFoods) {
      if (food.rank > maxRank && food.name != GOST_I18N.common.noMatch) {
        maxRank = food.rank;
        selectedFood = food;
      }
    }
    // 選択された最も低いランクの食事を選択
    gostData.gostRecommendation = selectedFood.name;

    //グリッド表示のために、PrimarilySelectedFoodsの他に、周辺の食事も取得
    // gostData.SecondalySelectedFoods を空の配列として初期化
    gostData.SecondarySelectedFoods = [];

    // eFilsIndex と GOSTLEVEL のオフセット範囲を -1, 0, 1 でループ
    for (let eFilsOffset = -1; eFilsOffset <= 1; eFilsOffset++) {
      for (let gostOffset = -1; gostOffset <= 1; gostOffset++) {
        // 各オフセットを適用した eFilsIndex と GOSTLEVEL を計算
        const adjustedEFilsIndex = gostParams.eFilsIndex + eFilsOffset;
        const adjustedGOSTLEVEL = gostParams.GOSTLEVEL + gostOffset;

        // getSelectedFoods を呼び出し、その結果を取得
        const result = this.getSelectedFoods(adjustedEFilsIndex, adjustedGOSTLEVEL);

        // 結果がエラーでなく、正しい場合にのみ配列に追加
        if (result && !result.error) {
          gostData.SecondarySelectedFoods.push({
            eFilsIndex: adjustedEFilsIndex,
            gostLevel: adjustedGOSTLEVEL,
            selectedFoods: result.selectedFoods
          });
        }else
        {
          gostData.SecondarySelectedFoods.push(result.error);
        }
      }
    }

  }

  private evaluateGcOc(gcOcData) {
    let totalScore = 0;

    for (var m of gcOcData.metrics) {
      // 残存歯 と 義歯 についての設問は別扱いにする
      if ( ! ["OC_TEETH", "OC_DENTURE"].includes(m.code) ){
        totalScore += (m.score == null ? 0 : m.score);
      }
    }

    // 義歯不使用のときは 残存歯の 設問結果をスコアとする。それ以外のときは 状態がよいほうのスコアを採用する
    const teethMetric = gcOcData.metrics.find( g => g.code == "OC_TEETH");
    const teethScore = teethMetric ? teethMetric.score??0 : 0;
    const dentureMetric = gcOcData.metrics.find( g => g.code == "OC_DENTURE");
    const dentureScore = dentureMetric ? dentureMetric.score??0 : 0;
    if (dentureScore == 0){
      totalScore += teethScore;
    }
    else{
      totalScore += Math.max( teethScore, dentureScore);
    }

    gcOcData.totalScore = totalScore;

    gcOcData.level = gcOcData.totalScore < 0 ? -1 : 0;

    return gcOcData;
  }

  //SCL, SCL_WT, SCLEVELの計算
  public evaluateSc(gostRecord) {

    this.calculateWithoutThicknessScore(gostRecord);
    this.calculateWithThicknessScore(gostRecord);

  }

  private calculateWithoutThicknessScore(gostRecord) {
    const withoutThicknessSteps = gostRecord.data.gostSCData.withoutThicknessSteps;

    if (withoutThicknessSteps == null) {
      gostRecord.data.gostSCData.totalScore = null;
      gostRecord.data.gostSCData.level = null; // データベースにはアップロードされない
      return;
    }

    let score = 0;
    let level = 1;
    let index = 0;

    let maxAmount = 0;

    // 成功または半分成功した中で最も多いamountを記録する
    for (var step of withoutThicknessSteps) {
      const amount: number = step.amount;
      for (var round of step.rounds) {

        if (!round.isMeasured) {
          continue;
        }

        let roundResult = this.evaluateScRound(round);

        if (roundResult["testResult"] == this.testResultDisp.good || roundResult["testResult"] == this.testResultDisp.acceptable) {

          if (roundResult["testResult"] == this.testResultDisp.good) {
            score += amount;
          }

          if (roundResult["testResult"] == this.testResultDisp.acceptable) {
            score += amount * 0.5;
          }

          maxAmount = amount > maxAmount ? amount : maxAmount;
          // let levelIfSuccess = amount == 1 ? 3 : amount == 3 ? 6 : amount == 5 ? 8 : amount == 30 ? 9 : amount == 100 ? 10 : 1;
          let levelIfSuccessIndex = amount == 1 ? 3 : amount == 3 ? 6 : amount == 5 ? 8 : amount == 30 ? 9 : amount == 100 ? 10 : 1;
          index = levelIfSuccessIndex > index ? levelIfSuccessIndex : index;
        }
      }
    }

    let levelAdjust = 0;
    // 上記で計算した amount以下がすべて成功していればそのまま、半分成功か失敗があれば Level を -1 する
    for (var step of withoutThicknessSteps) {
      const amount: number = step.amount;
      for (var round of step.rounds) {

        if (!round.isMeasured) {
          continue;
        }

        let roundResult = this.evaluateScRound(round);

        if (amount <= maxAmount) {
          if (roundResult["testResult"] == this.testResultDisp.acceptable || roundResult["testResult"] == this.testResultDisp.bad) {
            levelAdjust = -1;
          }
        }
      }
    }

    gostRecord.data.gostSCData.totalScore = score;
    gostRecord.data.gostSCData.index = index + levelAdjust;  //FILS が0-10段階で最も分解能があるためindexで管理
    gostRecord.data.gostSCData.level = this.SCMapIndex[index + levelAdjust] +1; // データベースにはアップロードされない //SCL の計算
  }

  private calculateWithThicknessScore(gostRecord) {
    const withThicknesSteps = gostRecord.data.gostSCData.withThicknessSteps;

    let level = 1; // 最低レベルは 1
    let index = 0;

    for (var step of withThicknesSteps) {
      const amount: number = step.amount;
      for (var round of step.rounds) {

        let roundResult = this.evaluateScRound(round);

        if ((roundResult["testResult"] == this.testResultDisp.good || roundResult["testResult"] == this.testResultDisp.acceptable) && round.isMeasured) {
          switch (amount) {
            case 1:
              level = level < 2 ? 2 : level;
              index = index < 3 ? 3 : index;
              break;
            case 3:
              level = level < 3 ? 3 : level;
              index = index < 4 ? 4 : index;
              break;
            case 5:
              level = level < 4 ? 4 : level;
              index = index < 6 ? 6 : index;
              break;
            case 30:
              level = level < 5 ? 5 : level;
              index = index < 7 ? 7 : index;

              break;
          }
        }
      }

    }

    gostRecord.data.gostSCData.withThicknessLevel = level; // データベースにはアップロードされない
    gostRecord.data.gostSCData.withThicknessIndex = index; // データベースにはアップロードされない

  }

  public evaluateScRound(round) {

    var convertedResult: any = {};

    convertedResult.swallowResult = this.convertToTPTN(round.swallowResult);
    convertedResult.coughResult = this.convertToTPTN(round.coughResult);

    convertedResult.swallowDelay = this.convertToTPTN(round.swallowDelay);
    convertedResult.abnormalSound = this.convertToTPTN(round.abnormalSound);
    convertedResult.multiSwallows = this.convertToTPTN(round.multiSwallows);
    convertedResult.throatClear = this.convertToTPTN(round.throatClear);
    convertedResult.otherAbbration = this.convertToTPTN(round.otherAbbration);

    convertedResult.otherAbnormality = null;
    if (convertedResult.swallowDelay == 'TP'
      || convertedResult.abnormalSound == 'TP'
      || convertedResult.multiSwallows == 'TP'
      || convertedResult.throatClear == 'TP'
      || convertedResult.otherAbbration == 'TP'
    ) {
      convertedResult.otherAbnormality = "TP";
    }

    // テスト結果評価
    convertedResult.testResult = this.testResultDisp.good;

    if (convertedResult.swallowResult == 'TN') {
      convertedResult.testResult = this.testResultDisp.bad;
    }

    if (convertedResult.coughResult == 'TP') {
      convertedResult.testResult = this.testResultDisp.bad;
    }

    if (convertedResult.otherAbnormality == 'TP') {
      if (convertedResult.testResult == this.testResultDisp.good) {
        convertedResult.testResult = this.testResultDisp.acceptable;
      }
    }

    if (convertedResult.swallowResult == null && convertedResult.coughResult == null && convertedResult.otherAbnormality == null) {
      convertedResult.testResult = this.testResultDisp.notMeasured;
    }

    return convertedResult;
  }

  convertToTPTN(originalValue) {
    // 表示用の判定のために FN→TP、FP→TN と読み替えて5値だったものを3値にする
    if (originalValue == "TP" || originalValue == "FN") {
      return "TP";
    }
    else {
      return "TN";
    }
    // return originalValue; // may be null or undefined
  }

  //filsindexとgostlevelをもとに選択された食事を取得
  private getSelectedFoods(filsValueIndex, gostValue) {
    // FILSとGOSTの範囲をチェック

    let gostLevel = gostValue;

    if (filsValueIndex < 0 || filsValueIndex > 10 || gostValue < 1 ) {
        return { error: GOST_I18N.error.outOfRange };
    }
    else if (gostValue > 6) {
      gostLevel = 6;
    }

    // FILS値に基づいて1位の食形態を決定
    const foodIndex = this.getFoodIndex(filsValueIndex);
    const selectedFoods = [];
    const ranking = this.rankingPatterns[gostLevel];
    const zeroIndex = ranking.indexOf(0);

    ranking.forEach((rank, index) => {
        //ランキング１位のゼロインデックスを基準に、各食事インデックスを取得して範囲内外を判定
        const offsetIndex = foodIndex + index - zeroIndex;
        if (offsetIndex >= 0 && offsetIndex < this.recommendations.length) {
            selectedFoods.push({ name: this.recommendations[offsetIndex], description: this.descriptions[offsetIndex],  rank: rank + 1 });

        } else {
            selectedFoods.push({ name: GOST_I18N.common.noMatch, description: GOST_I18N.common.noMatchDescription, rank: rank + 1 });
        }
    });

    return { selectedFoods };
}

//FILSのinedx値に基づいて1位の食形態のindexを取得
private getFoodIndex(filsValue) {
  // FILS値に基づいて1位を決定
  let foodIndex;
  if (filsValue < 0 || filsValue > 10) {
      return { error: GOST_I18N.error.filsOutOfRange };
  } else
  {
     foodIndex = this.SCMapIndex[filsValue ];
  }

  return foodIndex;
}

getRankClass(rank: number): string {
  return `rank-${rank}`;
}

getFoodDescription(name: string): string {
  const index = this.recommendations.indexOf(name);
  return this.recommendations[index] || '';
}

getStars(rank: number): string {
  return `${'★'.repeat(5 - rank)}${'☆'.repeat(rank - 1)}`;
}

  createEmptyGost2(common: DatabaseCacheService, msalService: MsalService) {
    let user = msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

        let now = new Date();
        let newGost2: any = {
            record :{
                id : this.newGostId,
                meta:{
                    measurer: {   userId: loginUserId,  lastName: '', firstName: ''  },
                    user: {  userId: common.getSelectedUserId(),  lastName: '',  firstName: '',  code: ''  },
                    location: {  sectionId: common.getSelectedSection().sectionId,  sectionName: common.getSelectedSection().sectionName  },
                },
                commonInfo : {
                    lastModifiedAt : getIsoDateTimeString(new Date()),
                    lastModifiedBy : loginUserId,
                },
                data :{
                    createdAt : getIsoDateTimeString(now),
                    asOfDate :  getIsoDateTimeString(now).substring(0,10),
                    recordType : "GOST",
                    version : "2",
                }
            },
            recordData :{

        data: {
          "gostOCData": {
            "totalScore": 0,
            "level": 0,
            "metrics": [
              // ここの中身に入る項目は gost-infos.component の initOriginalDataMetrics() で OC テーブルの項目に合わせて実行時に追加される

              // { "code": "OC_ORAL_HYGIENE", "score": null },
              // { "code": "OC_COGNITIVE_LEVEL", "score": null },
              // { "code": "OC_ARTICULATION_LEVEL", "score": null },
              // { "code": "OC_TEETH", "score": null },
              // { "code": "OC_DENTURE", "score": null },
              // { "code": "OC_RIGHT_ARM", "score": null },
              // { "code": "OC_LEFT_ARM", "score": null },
              // { "code": "OC_DISABILITY_LEVEL", "score": null } ,
            ]
          },

          "gostGCData": {
            "totalScore": 0,
            "level": 0,
            "metrics": [
              // ここの中身に入る項目は gost-infos.component の initOriginalDataMetrics() で GC テーブルの項目に合わせて実行時に追加される

              // { "code": "GC_CONSCIOUSNESS_LEVEL", "score": null },
              // { "code": "GC_TEMPERATURE", "score": null },
              // { "code": "GC_PULSE_LEVEL", "score": null },
              // { "code": "GC_SPO2", "score": null },
              // { "code": "GC_BREATH_LEVEL", "score": null },
              // { "code": "GC_ON_OXYGEN", "score": null},
              // { "code": "GC_SPUTUM", "score": null }
            ]
          },

          "gostSCData": {
            "totalScore": 0,
            "level": 0,
            "withoutThicknessSteps": [
              // ここの中身に入る steps / rounds は gost-infos.component の initOriginalDataMetrics() で SC テーブルの項目に合わせて実行時に追加される

              // {
              //   "amount" : 1,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1},  {   "round" : 2} ],
              // },
              // {
              //   "amount" : 3,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1},  {   "round" : 2} ],
              // },
              // {
              //   "amount" : 5,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1},  {   "round" : 2} ],
              // },
              // {
              //   "amount" : 30,   "testType" : "challenge",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1} ],
              // },
              // {
              //   "amount" : 100,   "testType" : "challenge",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1} ],
              // }
            ],
            "withThicknessSteps": [
              // ここの中身に入る steps / rounds は gost-infos.component の initOriginalDataMetrics() で SC テーブルの項目に合わせて実行時に追加される

              // {
              //   "amount" : 1,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1}  ],
              // },
              // {
              //   "amount" : 3,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1}  ],
              // },
              // {
              //   "amount" : 5,   "testType" : "stepwise",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1}  ],
              // },
              // {
              //   "amount" : 30,   "testType" : "challenge",  "testResult" : null,
              //   "rounds" : [  {   "round" : 1} ],
              // }
            ]
          }
        }
      }
    }
    return newGost2;
  }

}
